import { CALL_API } from '../middleware/ApiMiddleware';

export const USERS_FETCH_REQUEST = 'USERS_FETCH_REQUEST';
export const USERS_FETCH_SUCCESS = 'USERS_FETCH_SUCCESS';
export const USERS_FETCH_FAILURE = 'USERS_FETCH_FAILURE';
export const LOAD_MORE_USERS = 'LOAD_MORE_USERS';

export const USER_FETCH_REQUEST = 'USER_FETCH_REQUEST';
export const USER_FETCH_SUCCESS = 'USER_FETCH_SUCCESS';
export const USER_FETCH_FAILURE = 'USER_FETCH_FAILURE';

export const USER_FETCH_PROFILE_REQUEST = 'USER_FETCH_PROFILE_REQUEST';
export const USER_FETCH_PROFILE_SUCCESS = 'USER_FETCH_PROFILE_SUCCESS';
export const USER_FETCH_PROFILE_FAILURE = 'USER_FETCH_PROFILE_FAILURE';

export const USER_EDIT_PROFILE_REQUEST = 'USER_EDIT_PROFILE_REQUEST';
export const USER_EDIT_PROFILE_SUCCESS = 'USER_EDIT_PROFILE_SUCCESS';
export const USER_EDIT_PROFILE_FAILURE = 'USER_EDIT_PROFILE_FAILURE';

export const USER_CHANGE_PASSWORD_REQUEST = 'USER_CHANGE_PASSWORD_REQUEST';
export const USER_CHANGE_PASSWORD_SUCCESS = 'USER_CHANGE_PASSWORD_SUCCESS';
export const USER_CHANGE_PASSWORD_FAILURE = 'USER_CHANGE_PASSWORD_FAILURE';

export const EDIT_USER_SIGNATURE_REQUEST = 'EDIT_USER_SIGNATURE_REQUEST';
export const EDIT_USER_SIGNATURE_SUCCESS = 'EDIT_USER_SIGNATURE_SUCCESS';
export const EDIT_USER_SIGNATURE_FAILURE = 'EDIT_USER_SIGNATURE_FAILURE';

export const EDIT_USER_SIGNATURE_IMAGE_REQUEST = 'EDIT_USER_SIGNATURE_IMAGE_REQUEST';
export const EDIT_USER_SIGNATURE_IMAGE_SUCCESS = 'EDIT_USER_SIGNATURE_IMAGE_SUCCESS';
export const EDIT_USER_SIGNATURE_IMAGE_FAILURE = 'EDIT_USER_SIGNATURE_IMAGE_FAILURE';

export const DELETE_USER_SIGNATURE_IMAGE_REQUEST = 'DELETE_USER_SIGNATURE_IMAGE_REQUEST';
export const DELETE_USER_SIGNATURE_IMAGE_SUCCESS = 'DELETE_USER_SIGNATURE_IMAGE_SUCCESS';
export const DELETE_USER_SIGNATURE_IMAGE_FAILURE = 'DELETE_USER_SIGNATURE_IMAGE_FAILUREE';

export const FETCH_STAFF_TEXT_PROFILE_REQUEST = 'FETCH_STAFF_TEXT_PROFILE_REQUEST';
export const FETCH_STAFF_TEXT_PROFILE_SUCCESS = 'FETCH_STAFF_TEXT_PROFILE_SUCCESS';
export const FETCH_STAFF_TEXT_PROFILE_FAILURE = 'FETCH_STAFF_TEXT_PROFILE_FAILURE';

export const START_STAFF_TEXT_ENROLLMENT_REQUEST = 'START_STAFF_TEXT_ENROLLMENT_REQUEST';
export const START_STAFF_TEXT_ENROLLMENT_SUCCESS = 'START_STAFF_TEXT_ENROLLMENT_SUCCESS';
export const START_STAFF_TEXT_ENROLLMENT_FAILURE = 'START_STAFF_TEXT_ENROLLMENT_FAILURE';

export const RESEND_STAFF_TEXT_ENROLLMENT_REQUEST = 'RESEND_STAFF_TEXT_ENROLLMENT_REQUEST';
export const RESEND_STAFF_TEXT_ENROLLMENT_SUCCESS = 'RESEND_STAFF_TEXT_ENROLLMENT_SUCCESS';
export const RESEND_STAFF_TEXT_ENROLLMENT_FAILURE = 'RESEND_STAFF_TEXT_ENROLLMENT_FAILURE';

export const USER_CREATE_REQUEST = 'USER_CREATE_REQUEST';
export const USER_CREATE_SUCCESS = 'USER_CREATE_SUCCESS';
export const USER_CREATE_FAILURE = 'USER_CREATE_FAILURE';
export const USER_UPDATE_REQUEST = 'USER_UPDATE_REQUEST';
export const USER_UPDATE_SUCCESS = 'USER_UPDATE_SUCCESS';
export const USER_UPDATE_FAILURE = 'USER_UPDATE_FAILURE';

export const USER_DELETE_REQUEST = 'USER_DELETE_REQUEST';
export const USER_DELETE_SUCCESS = 'USER_DELETE_SUCCESS';
export const USER_DELETE_FAILURE = 'USER_DELETE_FAILURE';

export const USER_BULK_MODIFY_REQUEST = 'USER_BULK_MODIFY_REQUEST';
export const USER_BULK_MODIFY_SUCCESS = 'USER_BULK_MODIFY_SUCCESS';
export const USER_BULK_MODIFY_FAILURE = 'USER_BULK_MODIFY_FAILURE';

export const USER_RESET_PASSWORD_REQUEST = 'USER_RESET_PASSWORD_REQUEST';
export const USER_RESET_PASSWORD_SUCCESS = 'USER_RESET_PASSWORD_SUCCESS';
export const USER_RESET_PASSWORD_FAILURE = 'USER_RESET_PASSWORD_FAILURE';

export const USER_SET_PASSWORD_REQUEST = 'USER_SET_PASSWORD_REQUEST';
export const USER_SET_PASSWORD_SUCCESS = 'USER_SET_PASSWORD_SUCCESS';
export const USER_SET_PASSWORD_FAILURE = 'USER_SET_PASSWORD_FAILURE';

export const USER_VALIDATE_PASSWORD_REQUEST = 'USER_VALIDATE_PASSWORD_REQUEST';
export const USER_VALIDATE_PASSWORD_SUCCESS = 'USER_VALIDATE_PASSWORD_SUCCESS';
export const USER_VALIDATE_PASSWORD_FAILURE = 'USER_VALIDATE_PASSWORD_FAILURE';

export const USER_FORGOT_PASSWORD_REQUEST = 'USER_FORGOT_PASSWORD_REQUEST';
export const USER_FORGOT_PASSWORD_SUCCESS = 'USER_FORGOT_PASSWORD_SUCCESS';
export const USER_FORGOT_PASSWORD_FAILURE = 'USER_FORGOT_PASSWORD_FAILURE';

export const INSPECTION_ASSIGNEES_REQUEST = 'INSPECTION_ASSIGNEES_REQUEST';
export const INSPECTION_ASSIGNEES_SUCCESS = 'INSPECTION_ASSIGNEES_SUCCESS';
export const INSPECTION_ASSIGNEES_FAILURE = 'INSPECTION_ASSIGNEES_FAILURE';
export const LOAD_MORE_INSPECTION_ASSIGNEES_SUCCESS = 'LOAD_MORE_INSPECTION_ASSIGNEES_SUCCESS';

export const FETCH_USER_PREFERENCES_REQUEST = 'FETCH_USER_PREFERENCES_REQUEST';
export const FETCH_USER_PREFERENCES_SUCCESS = 'FETCH_USER_PREFERENCES_SUCCESS';
export const FETCH_USER_PREFERENCES_FAILURE = 'FETCH_USER_PREFERENCES_FAILURE';

export const UPDATE_USER_PREFERENCES_REQUEST = 'UPDATE_USER_PREFERENCES_REQUEST';
export const UPDATE_USER_PREFERENCES_SUCCESS = 'UPDATE_USER_PREFERENCES_SUCCESS';
export const UPDATE_USER_PREFERENCES_FAILURE = 'UPDATE_USER_PREFERENCES_FAILURE';

export const UPDATE_USER_PREFERENCES_FILTER_REQUEST = 'UPDATE_USER_PREFERENCES_REQUEST';
export const UPDATE_USER_PREFERENCES_FILTER_SUCCESS = 'UPDATE_USER_PREFERENCES_SUCCESS';
export const UPDATE_USER_PREFERENCES_FILTER_FAILURE = 'UPDATE_USER_PREFERENCES_FAILURE';

export const CASE_INSPECTION_ASSIGNEES_REQUEST = 'CASE_INSPECTION_ASSIGNEES_REQUEST';
export const CASE_INSPECTION_ASSIGNEES_SUCCESS = 'CASE_INSPECTION_ASSIGNEES_SUCCESS';
export const CASE_INSPECTION_ASSIGNEES_FAILURE = 'CASE_INSPECTION_ASSIGNEES_FAILURE';

export const GET_CRM_ASSIGNEE_REQUEST = 'GET_CRM_ASSIGNEE_REQUEST';
export const GET_CRM_ASSIGNEE_SUCCESS = 'GET_CRM_ASSIGNEE_SUCCESS';
export const GET_CRM_ASSIGNEE_FAILURE = 'GET_CRM_ASSIGNEE_FAILURE';
export const LOAD_MORE_GET_CRM_ASSIGNEE_SUCCESS = 'LOAD_MORE_GET_CRM_ASSIGNEE_SUCCESS';

export const GET_CRM_USERS_REQUEST = 'GET_CRM_USERS_REQUEST';
export const GET_CRM_USERS_SUCCESS = 'GET_CRM_USERS_SUCCESS';
export const GET_CRM_USERS_FAILURE = 'GET_CRM_USERS_FAILURE';
export const LOAD_MORE_GET_CRM_USERS_SUCCESS = 'LOAD_MORE_GET_CRM_USERS_SUCCESS';

export const GET_XERCE_ASSIGNEES_REQUEST = 'GET_XERCE_ASSIGNEES_REQUEST';
export const GET_XERCE_ASSIGNEES_SUCCESS = 'GET_XERCE_ASSIGNEES_SUCCESS';
export const GET_XERCE_ASSIGNEES_FAILURE = 'GET_XERCE_ASSIGNEES_FAILURE';
export const LOAD_MORE_GET_XERCE_ASSIGNEES_SUCCESS = 'LOAD_MORE_GET_XERCE_ASSIGNEES_SUCCESS';

export const GET_CE_ADMIN_USERS_REQUEST = 'GET_CE_ADMIN_USERS_REQUEST';
export const GET_CE_ADMIN_USERS_SUCCESS = 'GET_CE_ADMIN_USERS_SUCCESS';
export const GET_CE_ADMIN_USERS_FAILURE = 'GET_CE_ADMIN_USERS_FAILURE';

export const GET_CRM_ADMIN_USERS_REQUEST = 'GET_CRM_ADMIN_USERS_REQUEST';
export const GET_CRM_ADMIN_USERS_SUCCESS = 'GET_CRM_ADMIN_USERS_SUCCESS';
export const GET_CRM_ADMIN_USERS_FAILURE = 'GET_CRM_ADMIN_USERS_FAILURE';

export const FETCH_DELEGATE_WORK_REQUEST = 'FETCH_DELEGATE_WORK_REQUEST';
export const FETCH_DELEGATE_WORK_SUCCESS = 'FETCH_DELEGATE_WORK_SUCCESS';
export const FETCH_DELEGATE_WORK_FAILURE = 'FETCH_DELEGATE_WORK_FAILURE';

export const CREATE_DELEGATE_WORK_REQUEST = 'CREATE_DELEGATE_WORK_REQUEST';
export const CREATE_DELEGATE_WORK_SUCCESS = 'CREATE_DELEGATE_WORK_SUCCESS';
export const CREATE_DELEGATE_WORK_FAILURE = 'CREATE_DELEGATE_WORK_FAILURE';

export const UPDATE_DELEGATE_WORK_REQUEST = 'UPDATE_DELEGATE_WORK_REQUEST';
export const UPDATE_DELEGATE_WORK_SUCCESS = 'UPDATE_DELEGATE_WORK_SUCCESS';
export const UPDATE_DELEGATE_WORK_FAILURE = 'UPDATE_DELEGATE_WORK_FAILURE';

export const FETCH_RECENT_ASSIGNEE_REQUEST = 'FETCH_RECENT_ASSIGNEE_REQUEST';
export const FETCH_RECENT_ASSIGNEE_SUCCESS = 'FETCH_RECENT_ASSIGNEE_SUCCESS';
export const FETCH_RECENT_ASSIGNEE_FAILURE = 'FETCH_RECENT_ASSIGNEE_FAILURE';

export const USER_SEND_VERIFICATION_EMAIL_REQUEST = 'USER_SEND_VERIFICATION_EMAIL_REQUEST';
export const USER_SEND_VERIFICATION_EMAIL_SUCCESS = 'USER_SEND_VERIFICATION_EMAIL_SUCCESS';
export const USER_SEND_VERIFICATION_EMAIL_FAILURE = 'USER_SEND_VERIFICATION_EMAIL_FAILURE';

export const USER_VERIFY_EMAIL_REQUEST = 'USER_VERIFY_EMAIL_REQUEST';
export const USER_VERIFY_EMAIL_SUCCESS = 'USER_VERIFY_EMAIL_SUCCESS';
export const USER_VERIFY_EMAIL_FAILURE = 'USER_VERIFY_EMAIL_FAILURE';

const inspectionAssigneesURL = 'xerce/cases/inspection/assignees';
const crmAssigneeURL = 'agencies/crm/users';
const agencyBaseURL = 'admin/agencies';

export const fetchUsers = (params?: IUserListParams, hideLoading: boolean = false, replaceResults: boolean = true) => {
  const { offset } = params;

  return {
    [CALL_API]: {
      endpoint: 'users',
      method: 'get',
      authenticated: true,
      params,
      hideLoadingWidget: hideLoading,
      types: [
        USERS_FETCH_REQUEST,
        offset && offset > 0 && !replaceResults ? LOAD_MORE_USERS : USERS_FETCH_SUCCESS,
        USERS_FETCH_FAILURE,
      ],
    },
  };
};

export const fetchUser = (userId: number) => ({
  [CALL_API]: {
    endpoint: `users/${userId}`,
    method: 'get',
    authenticated: true,
    types: [USER_FETCH_REQUEST, USER_FETCH_SUCCESS, USER_FETCH_FAILURE],
  },
});

export const fetchUserProfile = () => ({
  [CALL_API]: {
    endpoint: 'users/profile',
    method: 'get',
    authenticated: true,
    types: [USER_FETCH_PROFILE_REQUEST, USER_FETCH_PROFILE_SUCCESS, USER_FETCH_PROFILE_FAILURE],
  },
});

export const editUserProfile = (user: IUserProfileRequest) => ({
  [CALL_API]: {
    endpoint: 'users/profile',
    method: 'put',
    body: user,
    authenticated: true,
    types: [USER_EDIT_PROFILE_REQUEST, USER_EDIT_PROFILE_SUCCESS, USER_EDIT_PROFILE_FAILURE],
  },
});

export const changeUserPassword = (currentPassword: string, newPassword: string) => ({
  [CALL_API]: {
    endpoint: 'users/profile/change-password',
    method: 'put',
    body: { old: currentPassword, new: newPassword },
    authenticated: true,
    types: [USER_CHANGE_PASSWORD_REQUEST, USER_CHANGE_PASSWORD_SUCCESS, USER_CHANGE_PASSWORD_FAILURE],
  },
});

export const editUserSignature = (signature: string) => ({
  [CALL_API]: {
    endpoint: 'users/profile/signature',
    method: 'put',
    body: { signature },
    authenticated: true,
    types: [EDIT_USER_SIGNATURE_REQUEST, EDIT_USER_SIGNATURE_SUCCESS, EDIT_USER_SIGNATURE_FAILURE],
  },
});

export const editUserSignatureImage = (signatureURL: string) => ({
  [CALL_API]: {
    endpoint: 'users/profile/digital-signature',
    method: 'put',
    body: { signatureURL },
    authenticated: true,
    types: [EDIT_USER_SIGNATURE_IMAGE_REQUEST, EDIT_USER_SIGNATURE_IMAGE_SUCCESS, EDIT_USER_SIGNATURE_IMAGE_FAILURE],
  },
});

export const deleteUserSignatureImage = (signatureURL: string) => ({
  [CALL_API]: {
    endpoint: 'users/profile/digital-signature',
    method: 'delete',
    body: { signatureURL },
    authenticated: true,
    types: [
      DELETE_USER_SIGNATURE_IMAGE_REQUEST,
      DELETE_USER_SIGNATURE_IMAGE_SUCCESS,
      DELETE_USER_SIGNATURE_IMAGE_FAILURE,
    ],
  },
});

// Background refreshes poll while a sign-up waits for CONFIRM, so they stay silent.
export const fetchStaffTextProfile = (isBackgroundRefresh = false) => ({
  [CALL_API]: {
    endpoint: 'users/profile/staff-text',
    method: 'get',
    authenticated: true,
    hideLoadingWidget: isBackgroundRefresh,
    hideDefaultAlert: isBackgroundRefresh,
    types: [FETCH_STAFF_TEXT_PROFILE_REQUEST, FETCH_STAFF_TEXT_PROFILE_SUCCESS, FETCH_STAFF_TEXT_PROFILE_FAILURE],
  },
});

// Errors are shown inline next to the phone field rather than as the default alert.
// hideLoadingWidget: the section drives its own submitting state. With hideDefaultAlert,
// a 409 dispatches neither ERROR nor FETCHING_COMPLETE, so the global spinner would stay up.
export const startStaffTextEnrollment = (phone: string) => ({
  [CALL_API]: {
    endpoint: 'users/profile/staff-text/enrollment',
    method: 'post',
    body: { phone },
    authenticated: true,
    hideDefaultAlert: true,
    hideLoadingWidget: true,
    types: [
      START_STAFF_TEXT_ENROLLMENT_REQUEST,
      START_STAFF_TEXT_ENROLLMENT_SUCCESS,
      START_STAFF_TEXT_ENROLLMENT_FAILURE,
    ],
  },
});

export const resendStaffTextEnrollment = () => ({
  [CALL_API]: {
    endpoint: 'users/profile/staff-text/enrollment/resend',
    method: 'post',
    authenticated: true,
    types: [
      RESEND_STAFF_TEXT_ENROLLMENT_REQUEST,
      RESEND_STAFF_TEXT_ENROLLMENT_SUCCESS,
      RESEND_STAFF_TEXT_ENROLLMENT_FAILURE,
    ],
  },
});

export const createUser = (user: IUser) => ({
  [CALL_API]: {
    endpoint: 'users',
    method: 'post',
    body: user,
    authenticated: true,
    types: [USER_CREATE_REQUEST, USER_CREATE_SUCCESS, USER_CREATE_FAILURE],
  },
});

export const updateUser = (userId: number, user: IUser) => ({
  [CALL_API]: {
    endpoint: `users/${userId}`,
    method: 'put',
    body: user,
    authenticated: true,
    types: [USER_UPDATE_REQUEST, USER_UPDATE_SUCCESS, USER_UPDATE_FAILURE],
  },
});

export const resetPasswordRequest = (userId: number) => ({
  [CALL_API]: {
    endpoint: `users/${userId}/reset-password`,
    method: 'get',
    authenticated: true,
    types: [USER_RESET_PASSWORD_REQUEST, USER_RESET_PASSWORD_SUCCESS, USER_RESET_PASSWORD_FAILURE],
  },
});

// TODO: remove old code if useless, also update reducer/user
export const usersBulkModify = (agencyId: number, users: IBulkModify) => ({
  [CALL_API]: {
    endpoint: `agencies/${agencyId}/staff/bulkModify`,
    method: 'post',
    body: users,
    authenticated: true,
    types: [USER_BULK_MODIFY_REQUEST, USER_BULK_MODIFY_SUCCESS, USER_BULK_MODIFY_FAILURE],
  },
});

export const fetchInspectionAssignees = (
  violationTypeIds: number[],
  violationIds?: number[],
  locationCustomFields?: IKeyValuePair,
  suggestAssignees?: boolean,
  loadMoreParams?: IUserFetchParams,
  replaceResults: boolean = true,
  hideLoadingWidget: boolean = false
) => {
  const params: any = loadMoreParams || {};

  if (violationTypeIds) {
    params.violationTypeIds = violationTypeIds;
  }
  if (violationIds) {
    params.violationIds = violationIds;
  }
  if (suggestAssignees) {
    params.suggestAssignees = suggestAssignees;
  }

  const { offset } = params;

  return {
    [CALL_API]: {
      endpoint: inspectionAssigneesURL,
      method: 'post',
      params,
      body: {
        locationCustomFields,
      },
      authenticated: true,
      types: [
        INSPECTION_ASSIGNEES_REQUEST,
        offset && offset > 0 && !replaceResults ? LOAD_MORE_INSPECTION_ASSIGNEES_SUCCESS : INSPECTION_ASSIGNEES_SUCCESS,
        INSPECTION_ASSIGNEES_FAILURE,
      ],
      hideLoadingWidget,
    },
  };
};

export const fetchCaseInspectionAssignees = (violationTypeIds: number[]) => {
  const params: any = {};

  if (violationTypeIds) {
    params.violationTypeIds = violationTypeIds;
  }

  return {
    [CALL_API]: {
      endpoint: inspectionAssigneesURL,
      method: 'post',
      params,
      body: {},
      authenticated: true,
      types: [CASE_INSPECTION_ASSIGNEES_REQUEST, CASE_INSPECTION_ASSIGNEES_SUCCESS, CASE_INSPECTION_ASSIGNEES_FAILURE],
      hideLoadingWidget: true,
    },
  };
};

export const fetchRecentAssignees = () => ({
  [CALL_API]: {
    endpoint: `xerce/cases/inspection/recent-assignees`,
    method: 'get',
    authenticated: true,
    types: [FETCH_RECENT_ASSIGNEE_REQUEST, FETCH_RECENT_ASSIGNEE_SUCCESS, FETCH_RECENT_ASSIGNEE_FAILURE],
  },
});

export const fetchUserPreferences = (hideLoadingWidget: boolean = false) => ({
  [CALL_API]: {
    endpoint: 'users/preferences',
    method: 'get',
    authenticated: true,
    types: [FETCH_USER_PREFERENCES_REQUEST, FETCH_USER_PREFERENCES_SUCCESS, FETCH_USER_PREFERENCES_FAILURE],
    hideLoadingWidget,
  },
});

export const updateUserPreferences = (userPreferences: IUserPreferences, preferenceType: ConfigProductType) => {
  const params: any = { preferenceType };

  return {
    [CALL_API]: {
      endpoint: 'users/preferences',
      method: 'put',
      params,
      authenticated: true,
      body: userPreferences,
      types: [UPDATE_USER_PREFERENCES_REQUEST, UPDATE_USER_PREFERENCES_SUCCESS, UPDATE_USER_PREFERENCES_FAILURE],
      hideLoadingWidget: true,
    },
  };
};

export const updateUserPreferencesFilters = (userPreferences: IUserPreferences, preferenceType: ConfigProductType) => {
  const params: any = { preferenceType };

  return {
    [CALL_API]: {
      endpoint: 'users/preferences/filters',
      method: 'put',
      params,
      authenticated: true,
      body: userPreferences,
      types: [
        UPDATE_USER_PREFERENCES_FILTER_REQUEST,
        UPDATE_USER_PREFERENCES_FILTER_SUCCESS,
        UPDATE_USER_PREFERENCES_FILTER_FAILURE,
      ],
      hideLoadingWidget: true,
    },
  };
};

export const getCRMAssignees = (
  params: IGetCRMAssigneeParams,
  replaceResults: boolean = true,
  hideLoadingWidget: boolean = false
) => {
  const { offset } = params;

  return {
    [CALL_API]: {
      endpoint: crmAssigneeURL,
      method: 'get',
      params,
      authenticated: true,
      types: [
        GET_CRM_ASSIGNEE_REQUEST,
        offset && offset > 0 && !replaceResults ? LOAD_MORE_GET_CRM_ASSIGNEE_SUCCESS : GET_CRM_ASSIGNEE_SUCCESS,
        GET_CRM_ASSIGNEE_FAILURE,
      ],
      hideLoadingWidget,
    },
  };
};

export const getCRMUsers = (
  params?: IUserFetchParams,
  replaceResults: boolean = true,
  hideLoadingWidget: boolean = false
) => {
  const offset = params && params.offset;

  return {
    [CALL_API]: {
      endpoint: crmAssigneeURL,
      method: 'get',
      authenticated: true,
      params: {
        status: CRMAssigneeStatus.ACTIVE,
        permission: [CRMPermission.BASIC, CRMPermission.OVERWRITE, CRMPermission.READ_ONLY],
        ...params,
      },
      types: [
        GET_CRM_USERS_REQUEST,
        offset && offset > 0 && !replaceResults ? LOAD_MORE_GET_CRM_USERS_SUCCESS : GET_CRM_USERS_SUCCESS,
        GET_CRM_USERS_FAILURE,
      ],
      hideLoadingWidget,
    },
  };
};

export const fetchXerceAssignees = (agencyId: number, params?: IUserFetchParams, replaceResults: boolean = true) => {
  const offset = params && params.offset;

  return {
    [CALL_API]: {
      endpoint: `${agencyBaseURL}/${agencyId}/users`,
      method: 'get',
      params: {
        productTypes: [ProductType.XERCE],
        xercePermissions: [ViolationTypeAccess.BASIC, ViolationTypeAccess.OVERWRITE],
        status: 'ACTIVE',
        ...params,
      },
      authenticated: true,
      types: [
        GET_XERCE_ASSIGNEES_REQUEST,
        offset && offset > 0 && !replaceResults ? LOAD_MORE_GET_XERCE_ASSIGNEES_SUCCESS : GET_XERCE_ASSIGNEES_SUCCESS,
        GET_XERCE_ASSIGNEES_FAILURE,
      ],
    },
  };
};

export const fetchCEAdminUsers = (agencyId: number) => ({
  [CALL_API]: {
    endpoint: `${agencyBaseURL}/${agencyId}/users`,
    method: 'get',
    authenticated: true,
    params: {
      status: 'ACTIVE',
      productTypes: [ProductType.XERCE],
      userType: UserType.CE_ADMIN,
    },
    types: [GET_CE_ADMIN_USERS_REQUEST, GET_CE_ADMIN_USERS_SUCCESS, GET_CE_ADMIN_USERS_FAILURE],
  },
});

export const fetchCRMAdminUsers = (agencyId: number) => ({
  [CALL_API]: {
    endpoint: `${agencyBaseURL}/${agencyId}/users`,
    method: 'get',
    authenticated: true,
    params: {
      status: 'ACTIVE',
      productTypes: [ProductType.CRM],
      userType: UserType.CRM_ADMIN,
    },
    types: [GET_CRM_ADMIN_USERS_REQUEST, GET_CRM_ADMIN_USERS_SUCCESS, GET_CRM_ADMIN_USERS_FAILURE],
  },
});

export const fetchDelegateWorkConfig = (hideLoadingWidget: boolean = false) => ({
  [CALL_API]: {
    endpoint: 'users/config-leave',
    method: 'get',
    authenticated: true,
    types: [FETCH_DELEGATE_WORK_REQUEST, FETCH_DELEGATE_WORK_SUCCESS, FETCH_DELEGATE_WORK_FAILURE],
    hideLoadingWidget,
  },
});

export const createDelegateWorkConfig = (body: IDelegateWorkRequest) => ({
  [CALL_API]: {
    endpoint: 'users/config-leave',
    method: 'post',
    body,
    authenticated: true,
    types: [CREATE_DELEGATE_WORK_REQUEST, CREATE_DELEGATE_WORK_SUCCESS, CREATE_DELEGATE_WORK_FAILURE],
  },
});

export const updateDelegateWorkConfig = (body: IDelegateWorkRequest) => ({
  [CALL_API]: {
    endpoint: 'users/config-leave',
    method: 'put',
    body,
    authenticated: true,
    types: [UPDATE_DELEGATE_WORK_REQUEST, UPDATE_DELEGATE_WORK_SUCCESS, UPDATE_DELEGATE_WORK_FAILURE],
  },
});

export const sendVerificationEmail = (email: string, crmToken: string, privateAppJWT: string) => ({
  [CALL_API]: {
    endpoint: 'users/verify',
    method: 'post',
    body: { email, crmToken },
    headers: {
      Authorization: `Bearer ${privateAppJWT}`,
    },
    authenticated: true,
    types: [
      USER_SEND_VERIFICATION_EMAIL_REQUEST,
      USER_SEND_VERIFICATION_EMAIL_SUCCESS,
      USER_SEND_VERIFICATION_EMAIL_FAILURE,
    ],
  },
});

export const verifyEmail = (token: string) => ({
  [CALL_API]: {
    endpoint: `users/verify?token=${token}`,
    method: 'get',
    authenticated: true,
    types: [USER_VERIFY_EMAIL_REQUEST, USER_VERIFY_EMAIL_SUCCESS, USER_VERIFY_EMAIL_FAILURE],
  },
});
